<template>
      <b-card class="card-challenges-post" :style="{'background-image': `url(${item.src})`}">
          <div>
            <h4>
              <PuSkeleton :loading="isLoading" :count="1" height="50px" width="220px">                              
                {{title}}
              </PuSkeleton>
            </h4>
            <h6>
              <PuSkeleton :loading="isLoading" :count="1" height="30px" width="100px">                                            
                {{subtitle}}
              </PuSkeleton>
            </h6>
            <p class="desc">
              <PuSkeleton :loading="isLoading" :count="1" width="60px">              
                {{desc}}
              </PuSkeleton>  
            </p>

            <b-button variant="outline" class="btn-outline" :to="link">
              {{linkTitle}}
              <span>
                <font-awesome-icon :icon="['far', 'arrow-right']"/>
              </span>
              </b-button>
          </div>
      </b-card>
</template>


<script>

//
export default {
  name: "CardChallengesPostCard",
  components:{ 
  },
  props:{
    subtitle:{
      type:String,
      default:'SRi lanka'
    },
    title:{
      type:String,
      default:'destination'
    },
    desc:{
      type:String,
      default:'lorem ipsum'
    },
    linkTitle:{
      type:String,
      default:'La destination'
    },
    link:{
      type:String,
      default:'#'
    },
  },
  data(){
    return {
      isLoading:true,
      item:{
        src:'/img/challenges-img.png',
      },      
    }
  },
  methods : {
  },  
  mounted (){

  },
  created(){
    setTimeout(() => {
      this.isLoading = false;
      // this.majData();
    },2000)      
  }  
}
</script>